import { useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import { useContext, useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxUser from "../../util/remote/ajaxUser";
import ajaxRole from "../../util/remote/ajaxRole";
import AuthContext from "../../Context/AuthContext";
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
const RegisterCompanyUserModal = (props) => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [stationID, setStationID] = useState(1);
  const [role_id, setRoleId] = useState("");
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // YYYY-MM-DD
  });
  const [ownerID, setOwnerID] = useState(null);
  // Avatar upload
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  // Roles
  const [Roles, setRoles] = useState([]);
  const fetchRolesList = async () => {
    const server_response = await ajaxRole.fetchRoleList({});
    if (server_response.status === "OK") {
      setRoles(server_response.details);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchRolesList();
  }, []);
  // Stations
  // Validation
  const allRowsFilled = () =>
    firstName && lastName && username && email && contact && role_id;
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const formData = {
      first_name: firstName,
      last_name: lastName,
      username: username,
      email: email,
      contact: contact,
      role_id: role_id,
      companyID: ownerID,
      company_owner: true,
      created_by: userId,
      avatar: avatarFile,
    };
    setLoading(true);
    const response = await ajaxUser.createUser(formData); // backend should accept FormData
    setLoading(false);
    if (response.status === "OK") {
      props.func();
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const handleAvatarChange = (e) => {
    e.preventDefault();
    let files = e.target.files;
    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
      const newItem = { file: e.target.result };
      setAvatarFile(e.target.result);
    };
  };
  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setUsername("");
    setEmail("");
    setContact("");
    setRoleId("");
    setAvatarFile(null);
    setAvatarPreview(null);
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  const [stationOwners, setStationOwners] = useState([]);
  const fetchData = async () => {
    const server_response =
      await ajaxStationOwners.liststation_owners_mini_data({});
    if (server_response.status === "OK") {
      const list =
        Array.isArray(server_response.details) &&
        server_response.details.map((d) => ({
          value: d.id,
          label: d.name,
        }));
      setStationOwners(list);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={handleAdd}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Station User"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Creating Company Level User"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register User</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* First Name */}
                    <div className="col-md-12">
                      <label>
                        First Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Last Name */}
                    <div className="col-md-12 mt-1">
                      <label>
                        Last Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Username */}
                    <div className="col-md-12 mt-1">
                      <label>
                        Username <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Email */}
                    <div className="col-md-12 mt-1">
                      <label>
                        Email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Contact */}
                    <div className="col-md-12 mt-1">
                      <label>
                        Contact <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Role */}
                    <div className="col-md-12 mt-1">
                      <label>
                        User Role <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        onChange={(option) => setRoleId(option.value)}
                        options={Roles.map((r) => ({
                          value: r.role_id,
                          label: r.role_name,
                        }))}
                        value={
                          Roles.find((r) => r.role_id === role_id) && {
                            value: role_id,
                            label: Roles.find((r) => r.role_id === role_id)
                              .role_name,
                          }
                        }
                        placeholder="Select Role"
                        isSearchable
                      />
                    </div>
                    {/* Station */}
                    {/* Owner */}
                    <div className="col-md-12">
                      <label>
                        Station Owner <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        onChange={(option) => setOwnerID(option.value)}
                        options={stationOwners}
                        value={ownerID}
                        placeholder="Select station owner"
                      />
                    </div>
                    {/* Avatar Upload */}
                    <div className="col-md-12 mt-3">
                      <label>Avatar</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleAvatarChange}
                        className="form-control"
                      />
                      {avatarPreview && (
                        <img
                          src={avatarPreview}
                          alt="Avatar Preview"
                          style={{
                            marginTop: "10px",
                            width: "120px",
                            height: "130px",
                            borderRadius: "5%",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterCompanyUserModal;
